<template>
  <el-select :clearable="clearable" filterable :size="size" v-model="value" :placeholder="placeholder" @change="changeHandle"
    :disabled="disabled">
    <el-option v-for="item in hospitalOptions" :key="item.hospitalId" :label="item.hospitalName"
      :value="item.hospitalId">
    </el-option>
  </el-select>
</template>

<script>
  import {
    getMyHospitalListApi,
    getAllHospitalListApi
  } from "@/util/api";

  export default {
    model: {
      prop: 'hospitalId',
      event: 'change'
    },
    props: {
      hospitalId: {
        type: String
      },
      all: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      size: {
        type: String,
        default: 'small'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      }
    },
    data() {
      return {
        value: null,
        hospitalOptions: []
      }
    },
    mounted() {
      this.loadData()
    },
    watch: {
      hospitalId: {
        handler: function(value) {
          this.value = value
        }
      }
    },
    methods: {
      loadData() {
        if (this.all) {
          getAllHospitalListApi({
            searchCond: {},
            orderBy: "[hospitalName] asc"
          }).then(res => {
            if (res.msgCode == 200) {
              this.hospitalOptions = res.responseData.modelData;
              if (this.hospitalOptions && this.hospitalOptions.length == 1) {
                this.changeHandle(this.hospitalOptions[0].hospitalId);
              } else if (this.hospitalOptions && this.hospitalId) {
                this.changeHandle(this.hospitalId);
              }
            } else {
              this.$message.error(res.msg)
            }
          });
        } else {
          getMyHospitalListApi().then(res => {
            if (res.msgCode == 200) {
              this.hospitalOptions = res.responseData
              if (this.hospitalOptions && this.hospitalOptions.length == 1) {
                this.changeHandle(this.hospitalOptions[0].hospitalId);
              } else if (this.hospitalOptions && this.hospitalId) {
                this.changeHandle(this.hospitalId);
              }
            } else {
              this.$message.error(res.msg)
            }
          }).catch()
        }
      },
      changeHandle(id) {
        this.value = id;
        let hopspitalObj = this.hospitalOptions.filter(h => {
          return h.hospitalId == id;
        });
        this.$emit('change', id, hopspitalObj && hopspitalObj.length > 0 ? hopspitalObj[0] : {});
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/business/HospitalSelect.vue